// utils/buildingTemplates.js

const buildingTemplates = [
  {
    id: "default",
    name: "default",
    image:
      "https://res.cloudinary.com/dlhfcdscf/image/upload/v1734873430/public/default_wipile.png",
  },
  {
    id: "green",
    name: "green",
    image:
      "https://res.cloudinary.com/dlhfcdscf/image/upload/v1734873431/public/green_vzaq7s.png",
  },
  {
    id: "red",
    name: "red",
    image:
      "https://res.cloudinary.com/dlhfcdscf/image/upload/v1734873430/public/red_g2zl8i.png",
  },
  {
    id: "macabi",
    name: "macabi",
    image:
      "https://res.cloudinary.com/dlhfcdscf/image/upload/v1734873429/public/macabi_autno4.png",
  },
  {
    id: "beitar",
    name: "beitar",
    image:
      "https://res.cloudinary.com/dlhfcdscf/image/upload/v1734873429/public/beitar_ludisp.png",
  },
  {
    id: "bio",
    name: "bio",
    image:
      "https://res.cloudinary.com/dlhfcdscf/image/upload/v1738581086/public/Screenshot_2025-02-03_130835_fyswsj.png",
  },
];

export default buildingTemplates;
